// extracted by mini-css-extract-plugin
export default {"sync-status":"ProjectCard-module__sync-status___VAzj6"};